module.exports = __webpack_public_path__ + "static/media/balanceQuestion.621e404a.mp3";